(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[268],{

/***/ 42207:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categoria/[categorySlug]/[page]",
      function () {
        return __webpack_require__(65964);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Categorys; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(39425);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/GlobalStyles/GlobalStyles.js
var GlobalStyles = __webpack_require__(51039);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 9 modules
var lib = __webpack_require__(57800);
;// CONCATENATED MODULE: ./src/queries/category/getCategoryProducts.ts
/*
 * File: getCategoryProducts.ts
 * Project: meki
 * File Created: Monday, 3rd May 2021 2:55:03 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Thursday, 29th December 2022 3:33:55 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2020 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getCategoryProducts(\n    $params: BestSellingProductsCategoryParams!\n    $categoryParams: GetCategoryParams!\n  ) {\n    bestSellingProductsCategory(params: $params) {\n      pageInfo {\n        totalPages\n        pageNumber\n      }\n      nodes {\n        id\n        uuid\n        slug\n        name\n        price\n        concentration\n        unit\n        quantity\n        package\n        composition\n        display\n        containerQuantity\n        container\n        availability {\n          status\n        }\n        categories {\n          id\n          name\n          slug\n        }\n        imagesUrl\n        activePrinciple\n        laboratory\n        isCheapestActivePrinciple\n        discount {\n          price\n          listPrice\n          type\n          stockRestriction\n          dateRestriction\n        }\n      }\n      brands {\n        brand\n        quantity\n      }\n    }\n\n    category(params: $categoryParams) {\n      id\n      name\n      slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getCategoryProducts = function() {
    return (0,lib/* gql */.Ps)(_templateObject());
};

// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/SearchContentContainer.tsx
var SearchContentContainer = __webpack_require__(99760);
// EXTERNAL MODULE: ./src/components/ProductFilterOptions.tsx
var ProductFilterOptions = __webpack_require__(11215);
// EXTERNAL MODULE: ./src/components/ProductsNotFound.tsx
var ProductsNotFound = __webpack_require__(98137);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Product/index.tsx + 5 modules
var Product = __webpack_require__(77616);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(76172);
// EXTERNAL MODULE: ./src/hooks/useBottomReach.ts
var useBottomReach = __webpack_require__(11514);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx
var Header = __webpack_require__(23722);
;// CONCATENATED MODULE: ./src/screens/category/index.tsx
/*
 * File: index.tsx
 * Project: meki
 * File Created: Monday, 3rd May 2021 3:14:26 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Monday, 27th November 2023 5:22:34 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2020 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 






















var ProductDrawer = dynamic_default()(function() {
    var promise = Promise.all(/* import() */[__webpack_require__.e(4567), __webpack_require__.e(8199), __webpack_require__.e(969)]).then(__webpack_require__.bind(__webpack_require__, 50969)).then(function(mod) {
        return mod.ProductDrawer;
    });
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50969)
            ];
        }
    }
});
var backgroundGlobalStyle = /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
    styles: {
        body: {
            backgroundColor: "#f9f9f9 !important"
        }
    }
});
var HeaderContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(700), {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingTop: 8
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(1230), {
        maxWidth: 1200,
        margin: "auto"
    }), _obj;
});
var BackButton = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        margin: "16px 0 12px 4px",
        width: "fit-content"
    };
});
function CategoryIndex(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    // Hooks init:
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(false), toggleDrawer = ref6[0], setToggleDrawer = ref6[1];
    var ref7 = (0,react.useState)(false), navigating = ref7[0], setNavigating = ref7[1];
    var ref8 = (0,react.useState)(0), totalFiltersCheck = ref8[0], setTotalFiltersCheck = ref8[1];
    // Queries:
    var queryParams = (0,react.useMemo)(function() {
        var brands = router.query.brands ? router.query.brands.split(",") : undefined;
        var priceRanges = router.query.priceRanges ? [
            router.query.priceRanges
        ].flat().map(function(priceRange) {
            var queryObject = Object.fromEntries(priceRange.split(";").map(function(range) {
                return range.split(":");
            }));
            return {
                start: +(queryObject === null || queryObject === void 0 ? void 0 : queryObject.start) ? +queryObject.start : undefined,
                stop: +(queryObject === null || queryObject === void 0 ? void 0 : queryObject.stop) ? +queryObject.stop : undefined
            };
        }) : undefined;
        return {
            brands: brands,
            priceRanges: priceRanges
        };
    }, [
        router.query
    ]);
    var variables = (0,react.useMemo)(function() {
        return {
            params: {
                pageNumber: 1,
                slug: router.query.categorySlug,
                filterBy: {
                    brands: queryParams.brands,
                    priceRanges: queryParams.priceRanges
                },
                sortBy: {
                    price: router.query.sortBy == "price" ? true : false,
                    alphabetically: router.query.sortBy == "alphabetically" ? true : false,
                    mostSelling: router.query.sortBy == "mostSelling" ? true : false
                }
            },
            categoryParams: {
                slug: router.query.categorySlug
            }
        };
    }, [
        queryParams.brands,
        queryParams.priceRanges,
        router.query.categorySlug,
        router.query.sortBy, 
    ]);
    var ref9 = (0,useQuery/* useQuery */.aM)(getCategoryProducts(), {
        variables: variables,
        skip: !router.query.categorySlug,
        fetchPolicy: "cache-and-network"
    }), freshData = ref9.data, loading = ref9.loading, fetchMore = ref9.fetchMore;
    var data = freshData || props.initialData;
    var categoryData = data === null || data === void 0 ? void 0 : data.category;
    var handleFetchMore = (0,react.useMemo)(function() {
        var ref, ref1;
        var _pageNumber;
        if ((data === null || data === void 0 ? void 0 : (ref = data.bestSellingProductsCategory) === null || ref === void 0 ? void 0 : ref.pageInfo.totalPages) <= ((_pageNumber = data === null || data === void 0 ? void 0 : (ref1 = data.bestSellingProductsCategory) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.pageNumber) !== null && _pageNumber !== void 0 ? _pageNumber : 1)) {
            return;
        }
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, _pageNumber;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchMore({
                                variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
                                    params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables.params), {
                                        pageNumber: ((_pageNumber = data === null || data === void 0 ? void 0 : (ref = data.bestSellingProductsCategory) === null || ref === void 0 ? void 0 : ref.pageInfo.pageNumber) !== null && _pageNumber !== void 0 ? _pageNumber : 1) + 1
                                    })
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.bestSellingProductsCategory) === null || ref === void 0 ? void 0 : ref.pageInfo.totalPages,
        data === null || data === void 0 ? void 0 : (ref1 = data.bestSellingProductsCategory) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.pageNumber,
        fetchMore,
        variables, 
    ]);
    var ref10 = (0,useBottomReach/* useBottomReach */.U)(handleFetchMore), loadingMore = ref10.loading;
    var handleToggleDrawer = (0,react.useCallback)(function(event) {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setToggleDrawer(!toggleDrawer);
    }, [
        toggleDrawer
    ]);
    var handleSort = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type) {
            var newRoute;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newRoute = function() {
                            return {
                                pathname: router.pathname,
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                    sortBy: type
                                })
                            };
                        };
                        setNavigating(true);
                        return [
                            4,
                            router.push(newRoute())
                        ];
                    case 1:
                        _state.sent();
                        setNavigating(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(type) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router
    ]);
    var handleTotalFiltersChecked = (0,react.useCallback)(function(total) {
        setTotalFiltersCheck(total);
    }, []);
    var handleCleanFilter = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var newRoute;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    newRoute = function() {
                        return {
                            pathname: router.pathname,
                            query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                brands: undefined,
                                priceRanges: undefined,
                                sortBy: router.query.sortBy
                            }))
                        };
                    };
                    setNavigating(true);
                    return [
                        4,
                        router.push(newRoute())
                    ];
                case 1:
                    _state.sent();
                    setNavigating(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        router
    ]);
    var ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            backgroundGlobalStyle,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                hasSearchBox: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchContentContainer/* SearchContentContainer */.I, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                        children: [
                            router.query.categorySlug && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,utils/* getRoute */.Bv)("subCategories", {
                                    categorySlug: router.query.categorySlug
                                }),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackButton, {
                                    color: "textPrimary",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                        "Atr\xe1s"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFilterOptions/* ProductFilterOptions */.z, {
                                totalFiltersCheck: totalFiltersCheck,
                                handleToggleDrawer: handleToggleDrawer,
                                handleSort: handleSort,
                                sortType: router.query.sortBy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                (data === null || data === void 0 ? void 0 : data.bestSellingProductsCategory) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDrawer, {
                                    handleToggleDrawer: handleToggleDrawer,
                                    toggleDrawer: toggleDrawer,
                                    data: data === null || data === void 0 ? void 0 : data.bestSellingProductsCategory,
                                    handleTotalFiltersChecked: handleTotalFiltersChecked,
                                    setNavigating: setNavigating
                                }),
                                (data === null || data === void 0 ? void 0 : (ref2 = data.bestSellingProductsCategory) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.nodes) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 || loading || navigating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Product/* Products */.Q, {
                                    title: categoryData === null || categoryData === void 0 ? void 0 : categoryData.name,
                                    data: navigating ? [] : (ref11 = data === null || data === void 0 ? void 0 : (ref4 = data.bestSellingProductsCategory) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.nodes) === null || ref5 === void 0 ? void 0 : ref5.map(function(product) {
                                        return {
                                            product: product
                                        };
                                    })) !== null && ref11 !== void 0 ? ref11 : [],
                                    loading: loading || loadingMore || navigating
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsNotFound/* ProductsNotFound */._, {
                                    onClick: handleCleanFilter
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/categoria/[categorySlug]/[page].tsx
/*
 * File: [page].tsx
 * Project: meki
 * File Created: Friday, 11th June 2021 8:03:17 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Monday, 27th November 2023 5:50:39 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 



var __N_SSG = true;
function Categorys(param) {
    var data = param.data;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* SEOHead */.R, {
                title: "Meki \xb7 ".concat(/reciente/.exec(router.query.categorySlug) ? "Productos Recientes" : /destacados/.exec(router.query.categorySlug) ? "Destacados" : (ref2 = (ref1 = (ref = data === null || data === void 0 ? void 0 : data.bestSellingProductsCategory.nodes[0]) === null || ref === void 0 ? void 0 : ref.categories.find(function(category) {
                    return category.slug == router.query.categorySlug;
                })) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref2 !== void 0 ? ref2 : "", " \xb7 ").concat(router.query.page)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryIndex, {
                initialData: data
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,3684,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(42207); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);